const getValueFromWindow = function getValueFromWindowHelper(prop, key) {
  const { seMarketplace } = window;

  if (
    !seMarketplace ||
    !Object.hasOwnProperty.call(seMarketplace, prop) ||
    !Object.hasOwnProperty.call(seMarketplace[prop], key)
  ) {
    return '';
  }


  return window.seMarketplace[prop][key];
};


export default getValueFromWindow;
